<template>
  <div class="page_article_block">
    <div class="page_title">
      {{ basicInfo.recruitment_name }}
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-sm-12 p-0">
        <div class="col-12 article_info_item">
          <span class="article_tag">報名起始日</span>{{ basicInfo.recruitment_enrollment_start_date || new Date() | moment('YYYY-MM-DD(ddd) A hh:mm') }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">報名截止日</span>{{ basicInfo.recruitment_enrollment_end_date || new Date() | moment('YYYY-MM-DD(ddd) A hh:mm') }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">繳費截止日</span>{{ basicInfo.recruitment_payment_due_date || new Date() | moment('YYYY-MM-DD(ddd) A hh:mm') }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">傳真電話</span>{{ basicInfo.recruitment_fax }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">聯絡電話</span>{{ basicInfo.recruitment_tel }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">E-mail</span>{{ basicInfo.recruitment_email }}
        </div>
      </div>
      <div class="col-12 col-md-6 col-sm-12 p-0">
        <div class="col-12 article_info_item">
          <span class="article_tag">聯絡人</span>{{ basicInfo.recruitment_contact_person }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">收款行</span>{{ basicInfo.recruitment_bank_branch }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">收款帳號</span>{{ basicInfo.recruitment_account_number }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">收款戶名</span>{{ basicInfo.recruitment_account_name || '國立臺灣科技大學４０２專戶' }}
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">企劃書</span>
          <a
            v-for="info in basicInfo.recruitment_business_proposal"
            :href="(info || { attachment_url: '#' }).attachment_url"
            target="_blank"
          >
            {{ (info || { attachment_file_name: '' }).attachment_file_name }}
            <br>
          </a>
        </div>
        <div class="col-12 article_info_item">
          <span class="article_tag">電子專刊 <span style="display:block; font-size: 1rem;">E-brochure</span></span>

          <span style="color: #ff1100;" v-if="!isAuthenticatedGetter && basicInfo.recruitment_session_pdf !== null "><b style="font-weight: bold;">請於登入後查看 Please log in</b></span>
          <template v-else>
            <a
                v-for="info in basicInfo.recruitment_session_pdf"
              :href="(info || { attachment_url: '#' }).attachment_url"
              target="_blank"
            >
              {{ (info || { attachment_file_name: '' }).attachment_file_name }}
              <br>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CampusRecruitingIntroduction',
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed:{
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isAuthenticatedGetter'
    ]),
  }
}
</script>
